import { SearchOutlined } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { useFetchCalculations } from "./useFetchCalculations";

export const FetchCalculationsButton = ({ sailorId, disabled }) => {
  const { run, loading } = useFetchCalculations();

  return (
    <LoadingButton
      loadingPosition="start"
      variant="contained"
      color="primary"
      size="small"
      startIcon={<SearchOutlined />}
      onClick={() => run(sailorId)}
      disabled={disabled}
      loading={loading}
    >
      Fetch Calculations
    </LoadingButton>
  );
};
